export default function QuietRoomCheck({ onConfirm, onBack }) {
  return (
    <div className="bg-[#111827] border border-[#1E2D3D] rounded-2xl p-6 sm:p-8 max-w-xl mx-auto">
      <div className="text-center mb-8">
        <div className="w-20 h-20 bg-[#22D3EE]/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-10 h-10 text-[#22D3EE]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M5.586 15H4a1 1 0 01-1-1v-4a1 1 0 011-1h1.586l4.707-4.707C10.923 3.663 12 4.109 12 5v14c0 .891-1.077 1.337-1.707.707L5.586 15z"
            />
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M17 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2"
            />
          </svg>
        </div>

        <p className="text-xs uppercase tracking-[0.2em] font-semibold text-[#22D3EE] mb-3">
          Environment Check
        </p>

        <h2 className="text-2xl sm:text-3xl font-medium text-[#F8FAFC] mb-4 font-['Outfit']">
          Are you in a quiet room?
        </h2>

        <p className="text-[#94A3B8] max-w-md mx-auto">
          Background noises like traffic, conversation, or appliances will affect your test results.
          Please find a quiet place before continuing.
        </p>
      </div>

      <div className="bg-[#1E293B] rounded-xl p-4 mb-8">
        <p className="text-[#64748B] text-sm flex items-start gap-3">
          <svg
            className="w-5 h-5 text-[#FBBF24] flex-shrink-0 mt-0.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <span>
            <strong className="text-[#94A3B8]">Tip:</strong> Turn off fans, TVs, and close
            windows if possible. The quieter your environment, the more accurate your results.
          </span>
        </p>
      </div>

      <div className="flex flex-col gap-3">
        <button
          onClick={onConfirm}
          className="w-full py-4 px-6 bg-[#22D3EE] text-[#0A0F1C] font-semibold rounded-lg hover:bg-[#67E8F9] transition-all flex items-center justify-center gap-2"
          data-testid="quiet-room-confirm-btn"
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
          I'm in a Quiet Room
        </button>

        <button
          onClick={onBack}
          className="w-full py-3 px-6 rounded-lg border border-[#334155] text-[#94A3B8] font-medium hover:bg-[#1E293B] hover:text-[#F8FAFC] transition-colors flex items-center justify-center gap-2"
          data-testid="quiet-room-back-btn"
        >
          <svg
            className="w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
          Back
        </button>
      </div>
    </div>
  );
}
